import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { Z_INDEX_NAV_WRAPPER } from '../../../../styles/zIndex';
import { ContentWrap, Css, ITheme, Responsive } from '../../../../ui';
import { Color } from '../../../../styles/Color';

export const List = styled.ul<{}, ITheme>`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	list-style-type: none;
	margin: 0;
	pointer-events: all;

	& > li {
		margin: 0;
		padding: 0;
	}
`;

export const Wrapper = styled('div', { shouldForwardProp: isPropValid })<
	{},
	ITheme
>`
	top: 0;
	left: 0;
	right: 0;
	z-index: ${Z_INDEX_NAV_WRAPPER};
	pointer-events: none;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-end;
	background-color: ${(props) => props.theme.color.primaryLight};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		display: none;
	}
`;

export const StyledContentWrap = styled(ContentWrap)`
	display: flex;
	justify-content: flex-end;
	width: 100%;
`;

export const SkipContentLink = styled.a<{}, ITheme>`
	position: absolute;
	left: ${Css.pxToRem(20)};
	top: 0;
	padding: ${Css.pxToRem(4)};
	transform: translateY(-100%);
	text-decoration: none;
	color: transparent;

	&:focus {
		transform: translateY(0%);
		margin-top: ${Css.pxToRem(6)};
		background: ${(props) => props.theme.color.brand};
		color: ${Color.OnBackground};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		display: none;
	}
`;
